/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractRubric
 */
export interface ContractRubric {
    /**
     * 
     * @type {string}
     * @memberof ContractRubric
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof ContractRubric
     */
    reimbursement_rate: number;
    /**
     * 
     * @type {string}
     * @memberof ContractRubric
     */
    rubric: string;
    /**
     * 
     * @type {number}
     * @memberof ContractRubric
     */
    sort_order: number;
}

/**
 * Check if a given object implements the ContractRubric interface.
 */
export function instanceOfContractRubric(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "reimbursement_rate" in value;
    isInstance = isInstance && "rubric" in value;
    isInstance = isInstance && "sort_order" in value;

    return isInstance;
}

export function ContractRubricFromJSON(json: any): ContractRubric {
    return ContractRubricFromJSONTyped(json, false);
}

export function ContractRubricFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractRubric {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'reimbursement_rate': json['reimbursement_rate'],
        'rubric': json['rubric'],
        'sort_order': json['sort_order'],
    };
}

export function ContractRubricToJSON(value?: ContractRubric | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'reimbursement_rate': value.reimbursement_rate,
        'rubric': value.rubric,
        'sort_order': value.sort_order,
    };
}

